<template>
  <div class="settings-section">
    <h4 class="text-h4 q-mt-none q-mb-lg">
      {{ $t('userPanel.settings.photoSalesTitle') }}
    </h4>
    <div class="description-card q-pa-md q-mb-lg">
      <div class="row items-center">
        <div class="col-auto q-mr-md">
          <q-icon name="info" color="info" size="24px" />
        </div>
        <div class="col">
          {{ $t('userPanel.settings.bulkSaleDescription') }}
        </div>
      </div>
    </div>

    <q-form class="photo-sales-form" @submit.prevent="submitForm">
      <div class="form-content">
        <q-card flat bordered class="global-settings-card q-pa-md">
          <div class="row items-center q-mb-md">
            <div class="col-12">
              <q-checkbox
                v-model="form.disableBulkSale"
                :label="$t('userPanel.settings.disableBulkSale')"
                class="text-weight-medium"
                color="primary"
              />
            </div>
          </div>

          <div class="row q-mb-md">
            <div class="col-12">
              <q-input
                v-model.number="form.singlePhotoPrice"
                :label="$t('userPanel.settings.singlePhotoPrice')"
                type="number"
                min="4"
                step="0.1"
                :rules="[requiredRule, minPriceRule(4)]"
                hide-bottom-space
                class="number-input"
                :disable="!form.disableBulkSale"
                filled
                dense
              />
            </div>
          </div>

          <div class="row justify-end">
            <q-btn
              type="submit"
              color="primary"
              :label="$t('common.save')"
              :loading="loading"
              unelevated
              rounded
              class="q-px-md"
            />
          </div>
        </q-card>
      </div>
    </q-form>
  </div>
</template>

<script>
import { Notify } from 'quasar';

export default {
  name: 'SettingsCardGlobal',
  props: {
    user: { type: Object, required: true },
    initialFormData: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    requiredRule: { type: Function, required: true },
    minPriceRule: { type: Function, required: true },
  },
  data() {
    return {
      form: { ...this.initialFormData },
    };
  },
  watch: {
    initialFormData: {
      handler(newVal) {
        this.form = { ...newVal };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    submitForm() {
      if (this.form.disableBulkSale) {
        const rules = [this.requiredRule, this.minPriceRule(4)];
        const value = this.form.singlePhotoPrice;
        const isValid = rules.every((rule) => rule(value) === true);

        if (!isValid) {
          Notify.create({
            message: this.$t('validation.minPrice', { min: 4 }),
            type: 'negative',
            position: 'bottom',
            timeout: 3000,
          });

          return;
        }
      }

      this.$emit('save', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-section {
  @extend .settings-section;
}

.description-card {
  @extend .description-card;
  border-left: 4px solid $info;
}

.global-settings-card {
  border-radius: 8px;
  transition: all 0.3s ease;
  background-color: #f4f4f4;
}

.photo-sales-form {
  max-width: 450px;
  margin: 0 auto;
}

.number-input {
  width: 100%;
}
</style>
